import moment from "moment-timezone";

export default class {

  // #region Validadores //

  static isMObject(val) {
    if (typeof val != "object")
      return false;

    if (val == null)
      return false;

    if (Object.keys(val).length == 0)
      return false;

    return true;
  }

  static isValidParams(params, fields) {

    if (!Array.isArray(fields) || fields.length == 0)
      return false;

    if ((typeof params != "object" || params == null) && (!Array.isArray(fields) || fields.length == 0)) {
      return false;
    }

    let erros = [];
    for (f of fields) {
      if (!this.isValid(params[f]))
        erros.push(f);
    }

    return erros;

  }

  static isValid(val) { 
    return !(typeof val == "undefined" || val == null || val === "" || val === 0);
  }

  static isGetStrNotEmpty(val) {
    if (typeof val != "string")
      return false;

    val = val.trim();

    if (val == "")
      return false;

    return val;
  }

  static validString(val, def = "") {
    if (typeof def != "string")
      def = "";

    if (typeof val == "string")
      return val;

    return def;
  }

  static validFloat(val, def = 0) {
    if (typeof def != "number")
      def = 0;

    if (typeof val == "number")
      return parseFloat(val.toFixed(2));

    return def;
  }

  static validInteger(val, def = 0) {
    if (typeof def != "number")
      def = 0;

    if (typeof val == "number")
      return parseInt(val);

    return def;
  }

  static validObject(val, def = {}) {
    if (typeof def != "object")
      def = {};

    if (typeof val == "object" && val != null)
      return val;

    return def;
  }

  static validDate(val, def = null) {
    if (typeof def != "object")
      def = null;

    if (_.isDate(val))
      return val;

    if (typeof val == "string" && val != "" && val.includes("T"))
      return new Date(val);

    return def;
  }
  static dateFormat(date, format = "DD/MM/YYYY HH:mm:ss") {
    if(typeof date != "undefined" && date != null && date != "") {
      return moment(date, true).tz('America/Sao_Paulo').format(format);
    }
    return "";
  }

  static validArray(val, def = []) {
    if (typeof def != "object" || !Array.isArray(def))
      def = [];

    if (typeof val == "object" && val != null) {

      if (Array.isArray(val)) {
        return val;
      }

      const k = Object.keys(val);
      let i;
      for (i = 0; i < k.length && k[i] == i; i++);
      if (i == k.length)
        return Object.values(val);

    }

    return def;
  }

  static validBoolean(val, def = false) {
    if (typeof def != "boolean")
      def = false;

    if (typeof val == "boolean")
      return val;

    return def;
  }

  static isCPF(strCPF) {
    strCPF = strCPF.replace(/[^0-9]/g, "");

    var i;
    var Soma;
    var Resto;
    Soma = 0;

    if (strCPF == "00000000000") return false;

    for (i = 1; i <= 9; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;

    return true;
  }

  static isCNPJ(cnpj) {
    var i;

    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj == "") return false;

    if (cnpj.length != 14) return false;

    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999"
    )
      return false;

    // Valida DVs
    var tamanho = cnpj.length - 2;
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado != digitos.charAt(1)) return false;

    return true;
  }

  // #endregion Validadores //

  // #region Formatadores //

  static formatPhone(phone) {
    return '(' + phone.substr(0, 2) + ') ' + phone.substr(2, phone.length - 6) + '-' + phone.substr(-4);
  }

  static formatCurrency(val, prefix = 'R$ ') {

    if(prefix === false)
      prefix = '';

    if(typeof val == "string")
      val = parseFloat(val);
    
    if(typeof val != "number" || isNaN(val))
      return prefix + "Erro";

    return prefix + (new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val));

  }

  static formatCnpjCpf(value) {
    const cnpjCpf = value.replace(/\D/g, "");

    if (cnpjCpf.length === 11) {
      return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    }

    return cnpjCpf.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      "$1.$2.$3/$4-$5"
    );
  }

  static formatStrDateToBr(date) {
    if (typeof date != "string" || date == "")
      return "";
    return date.split("-").reverse().join("/");
  }

  static formatStrDateToBD(date) {
    if (typeof date != "string" || date == "")
      return "";
    return date.split("/").reverse().join("-");
  }

  static formatStrDateTimeToBr(date) {
    if (typeof date != "string" || date == "")
      return "";
    var dateTime = date.split(" ");
    return dateTime[0].split("-").reverse().join("/") + " " + dateTime[1];
  }

  static formatStrDateTimeToBD(date) {
    if (typeof date != "string" || date == "")
      return "";
    var dateTime = date.split(" ");
    return dateTime[0].split("/").reverse().join("-") + " " + dateTime[1];
  }

  static formatObjDate(date, format = "DD/MM/YYYY HH:mm:ss") {
    if(typeof date != "undefined" && date != null && date != "") {
      return moment(date, true).tz('America/Sao_Paulo').format(format);
    }
    return "";
  }

  static strToDate(date, format = "DD/MM/YYYY") {

    if (typeof date == 'string' && date != ''){
      return moment(date, format, true).tz('America/Sao_Paulo').toDate();
    } else if (date instanceof Date) {
      return date;
    }

    return null;

  }

  static normalizeStr(str, caseSensitive = 'N') {
    if (typeof str != "string")
      return "";
    caseSensitive = caseSensitive.toLowerCase();
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").trim();
    if (caseSensitive == 'l')
      str = str.toLowerCase();
    else if (caseSensitive == 'u')
      str = str.toUpperCase();
    return str;
  }

  // #endregion Formatadores //

  // #region Utilitários //

  static getStdObject(obj) {
    if(typeof obj == "undefined" || obj == null)
      return null;
    return JSON.parse(JSON.stringify(obj));
  }

  static calcularDiferencaEmMinutos(data1, data2) {
    // Converter as datas para milissegundos
    // Converter as datas para milissegundos
    const time1 = data1.getTime();
    const time2 = data2.getTime();

    // Calcular a diferença em milissegundos
    const diferencaEmMilissegundos = time1 - time2;

    // Converter a diferença para minutos
    const diferencaEmMinutos = Math.floor(diferencaEmMilissegundos / 1000);

    return diferencaEmMinutos;
  }
  
  // static isTouchDevice() {
  //   return (('ontouchstart' in window) ||
  //     (navigator.maxTouchPoints > 0) ||
  //     (navigator.msMaxTouchPoints > 0));
  // }

  static isMobileOrTablet() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  static isMobileCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  static slugify(text) {
    if(typeof text == "undefined")
      return "";
    return text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/ /g,"-").toLowerCase().trim();
  }

  // #endregion Utilitários //

}